// extracted by mini-css-extract-plugin
module.exports = {"CustomImage":"CustomImage_CustomImage__3k_oT","round":"CustomImage_round__ZMSME","bgWhite":"CustomImage_bgWhite__34gWH","bgGray":"CustomImage_bgGray__1hVNZ"};